const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeature4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M430.64,200.94H413.25a96.06,96.06,0,0,0,3.45-25.18C417.36,93,316.43,48.23,255.88,103.58H81.28A49.34,49.34,0,0,0,32,152.86v197a15.82,15.82,0,0,0,26.37,11.66l43.84-40.24a14.91,14.91,0,0,1,10.27-4h67v48a49.41,49.41,0,0,0,49.36,49.36H399.52a15,15,0,0,1,10.35,4.05l43.68,40.16A15.87,15.87,0,0,0,480,447.26v-197a49.38,49.38,0,0,0-49.36-49.28ZM400.7,175.76A80.79,80.79,0,0,1,320,256.45c-107-4.43-107-157,0-161.39A80.79,80.79,0,0,1,400.7,175.76ZM112.48,301.34a30.74,30.74,0,0,0-21.17,8.27L48,349.9v-197a33.32,33.32,0,0,1,33.28-33.28H241.45a96.33,96.33,0,0,0-14.7,81.36H210.88a31.36,31.36,0,0,0-31.36,31.28v69.12ZM420.77,407a30.81,30.81,0,0,0-21.25-8.34H228.88a33.39,33.39,0,0,1-33.36-33.36V232.22a15.33,15.33,0,0,1,15.36-15.28h21.76a96.76,96.76,0,0,0,174.72,0h23.28A33.36,33.36,0,0,1,464,250.22l.38,196.91Z",
    style: {
      fill: "#0096ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.72,160a14,14,0,0,0,5.12,15.74l21.31,15.48L277,216.24A14.08,14.08,0,0,0,298.68,232L320,216.51,341.32,232A14.08,14.08,0,0,0,363,216.24l-8.14-25.06,21.31-15.48a14.08,14.08,0,0,0-8.28-25.48H341.54l-8.15-25.06a14.08,14.08,0,0,0-26.78,0l-8.15,25.06H272.12a14.05,14.05,0,0,0-13.4,9.74Z",
    style: {
      fill: "#0096ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.2,304.27a8.35,8.35,0,0,1,8.35-8.35H429.88a8.36,8.36,0,1,1,0,16.71H234.56a8.36,8.36,0,0,1-8.36-8.35Z",
    style: {
      fill: "#0096ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.2,344.74a8.37,8.37,0,0,1,8.35-8.36H429.88a8.36,8.36,0,1,1,0,16.71H234.56a8.35,8.35,0,0,1-8.36-8.34Z",
    style: {
      fill: "#0096ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.92,172.46a8.34,8.34,0,0,1,8.34-8.36H186.59a8.36,8.36,0,0,1,0,16.71H81.27a8.35,8.35,0,0,1-8.35-8.35Z",
    style: {
      fill: "#0096ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.92,212.92a8.34,8.34,0,0,1,8.34-8.35h65.32a8.35,8.35,0,1,1,0,16.7H81.27a8.34,8.34,0,0,1-8.35-8.34Z",
    style: {
      fill: "#0096ff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature4);
export default __webpack_public_path__ + "static/media/feature4.a23e9f6e51cf8b542c15396e29365a03.svg";
export { ForwardRef as ReactComponent };